import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: SF Pro Display, sans-serif;
    font-weight: 500;
  }

  * {
    border-style: none;
    box-sizing: border-box;

  }

  img {
    user-select: none;
  }

  ::placeholder {
    // @ts-ignore
    color: ${({ theme } : any) => theme.color.placeholder}
  }
`;

export default GlobalStyle;
